import $ from "jquery";

export function removeFormSubmitStatus() {
    $('form').each(function () {
        $(this).removeClass('submit');
    });
}
